import {createSlice} from "@reduxjs/toolkit"
import {loadWorkspace} from "./workspaceSlice"

const dashboardModalControlSlice = createSlice({
	name: "dashboardModalControl",
	initialState: {
		workspaceManager: false,
		contactModal: false,
		workspacePermissions: false,
		helpModal: false,
		shareArticlesModal: false,
	},
	reducers: {
		openWorkspaceManager: (state) => {
			state.workspaceManager = true
		},
		closeWorkspaceManager: (state) => {
			state.workspaceManager = false
		},
		openContactModal: (state) => {
			state.contactModal = true
		},
		closeContactModal: (state) => {
			state.contactModal = false
		},
		openWorkspacePermissions: (state) => {
			state.workspacePermissions = true
		},
		closeWorkspacePermissions: (state) => {
			state.workspacePermissions = false
		},
		openHelpModal: (state) => {
			state.helpModal = true
		},
		closeHelpModal: (state) => {
			state.helpModal = false
		},
		openShareArticlesModal: (state) => {
			state.shareArticlesModal = true
		},
		closeShareArticlesModal: (state) => {
			state.shareArticlesModal = false
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(loadWorkspace.fulfilled, dashboardModalControlSlice.caseReducers.closeWorkspaceManager)
			.addCase(loadWorkspace.rejected, dashboardModalControlSlice.caseReducers.closeWorkspaceManager)
	}
})

export const {
	openWorkspaceManager,
	closeWorkspaceManager,
	openWorkspacePermissions,
	closeWorkspacePermissions,
	openContactModal,
	closeContactModal,
	openHelpModal,
	closeHelpModal,
	openShareArticlesModal,
	closeShareArticlesModal,
} = dashboardModalControlSlice.actions

export const selectWorkspaceManagerOpen = (state) => state.dashboardModalControl.workspaceManager
export const selectOpenContact = (state) => state.dashboardModalControl.contactModal
export const selectOpenWorkspacePermissions = (state) => state.dashboardModalControl.workspacePermissions
export const selectHelpModal = (state) => state.dashboardModalControl.helpModal
export const selectShareArticlesModal = (state) => state.dashboardModalControl.shareArticlesModal

export default dashboardModalControlSlice.reducer